<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-2">
            <smallBar></smallBar>
          </div>
          <div class="col-md-10">
				    <div class="widget-wrap">
				    	<dateFilter :show_month=false :now_year="now_year" :now_month="now_month" :years="years" @changeYear="changeYear" @changeMonth="changeMonth"></dateFilter>
				    	<h4>
				    		{{now_year}}年度預算管理
				    	</h4>
				    	<p>依照分類產生預算項目，若想增加預算項目請前往分類</p>
				    	<div class="clear"></div>	
				    	<div v-for="year_budget in filtedYearBudget()">
				    		<table class="table table-bordered">
				    			<tr>
				    				<th class="text-center" style="width:25%">項目</th>
				    				<th class="text-center" style="width:25%">年預算</th>
				    				<th class="text-center" style="width:25%">已使用預算/可用預算</th>
				    				<th class="text-center" style="width:25%">警示週期</th>
				    			</tr>
				    			<tr v-for="item in year_budget.year_budget_items">
				    				<td class="text-left">{{item.name}}</td>
				    				<td class="text-right">
				    					<input class="form-control" v-model="item.amount" 
		                    v-if="canEditColumn('item_amount',item.id)"
		                    @keydown.enter="$event.target.blur()" 
		                    v-on:blur="updateItem(item)"
		                    v-bind:ref="('item_amount'+item.id)"
		                  >
				    					<div v-else >
				    						<span class="pointer" v-if="item.amount == ''" @click="editColumn('item_amount',item.id)">$ 0 <i class="pointer fa fa-pencil-alt"></i></span>
				    						<span class="pointer" v-else @click="editColumn('item_amount',item.id)">$ {{item.amount.toLocaleString()}} <i class="pointer fa fa-pencil-alt"></i></span>
				    					</div>
				    				</td>
				    				<td class="text-right">
				    					<span v-html="usedBudget(item)"></span>
				    				</td>
				    				<td>
				    					<select class="form-control" v-model="item.alert_type" 
		                    v-if="canEditColumn('item_alert_type',item.id)"
		                    @change="updateItem(item)"
		                    v-on:blur="updateItem(item)"
		                    v-bind:ref="('item_alert_type'+item.id)"
		                  >
		                  	<option value="no">不警示</option>
		                  	<option value="month">按月提醒</option>
		                  	<option value="season">按季提醒</option>
		                	</select>
				    					<span v-else class="pointer" @click="editColumn('item_alert_type',item.id)" v-html="periodName(item.alert_type)"></span>
				    				</td>
				    			</tr>
				    		</table>
				    		<h4 class="text-right">總預算：$ {{totalBudget(year_budget).toLocaleString()}} </h4>
				    	</div>
				    </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import smallBar from './SmallBar.vue';
import dateFilter from './DateFilter.vue';
import moment from 'moment';

export default {
  name: 'year_budgets',
  data() {
    return {
    	year_budgets: [],
    	years:[],
    	moneys: [],
    	now_year: new Date().getFullYear(),
    	now_month:new Date().getMonth(), 
    	editColumnName: "",
      editColumnId: "",
      temp_item: {},
    }
  },
  created() {
    this.getYearBudgets()
    this.getMoneys()
  },
  components: {
    smallBar,dateFilter
  },
  props: ['toggle_aside'],
  methods: {
  	canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
  	sumExpendFromItem(item){
  		var total = 0
  		$.each(this.filterMoneysFromYearBudgetItem(item),function(i,e){
  			total += e.amount
  		})
  		return total
  	},
  	filterMoneysFromYearBudgetItem(item){
  		return this.moneys.filter(m => m.money_category_id == item.money_category_id && new Date(m.date).getFullYear() == this.now_year)
  	},
    getYearBudgets(){
      let vm = this
      this.axios.get('finances/year_budgets')
      .then(function(response) {
        if (response.status == 200) {
          vm.year_budgets = response['data']['data']['current_collection']
          vm.years = response['data']['data']['years']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    getMoneys(){
      let vm = this
      this.axios.get('finance_moneys')
      .then(function(response) {
        if (response.status == 200) {
          vm.moneys = response['data']['data']['finance_moneys']
          // vm.years = response['data']['data']['years']
          // vm.categories = response['data']['data']['money_categories']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    filtedYearBudget(){
    	let vm = this
    	var result = this.year_budgets.filter(m => m.year == vm.now_year)
    	return result
    },
    updateItem(item){
    	let vm = this
    	vm.finishedEditColumn()
    	this.axios.put('finances/year_budgets_items/'+item.id, {
        year_budget_item: item,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {
          
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
		    );
      });
    },
    usedBudget(item){
    	let vm = this
    	var used_budget = this.sumExpendFromItem(item)
    	var unit = 0
    	var base = 12
    	var result = '$ '+ used_budget.toLocaleString()

    	if(item.alert_type == 'no'){
    		return result 
    	}

    	for(var i=0;i<12;i++){
			　if(new Date(vm.now_year, i, 1) <= new Date()){
					unit = i+1
				}
			}

			if(item.alert_type == 'season'){
				unit = Math.ceil(unit/3)
				base = 4
			}

    	if(item.amount != 0){
    		var budget = parseInt(item.amount*unit/base)
    		result = result + '/ $ ' + budget.toLocaleString()
    		if(budget < used_budget){
    			result = '<span class="label label-danger mr-2"><i class="fas fa-exclamation"></i></span>' + result
    		}
    	}
    	return result 
    },
    totalBudget(year_budget){
    	var total = 0
  		$.each(year_budget.year_budget_items,function(i,e){
  			if(e.amount != ''){
  				total += parseInt(e.amount)
  			}
  		})
  		return total
    },
    periodName(type){
    	switch(type){
	    	case 'no':
	    		return '不警示 <i class="pointer fa fa-pencil-alt"></i>'
	    	case 'month':
	    		return '<span class="label label-success">按月提醒</span> <i class="pointer fa fa-pencil-alt"></i>'
	    	case 'season':
	    		return '<span class="label label-warning">按季提醒</span> <i class="pointer fa fa-pencil-alt"></i>'
	    }
    },
    changeYear(year){
    	this.now_year = year
    },
    changeMonth(month){
    	this.now_month = month
    }
  }
}
</script>


// WEBPACK FOOTER //
// YearBudget.vue?4ed87d37